module.exports = __webpack_public_path__ + "media/images/liv__landingImage--mobile-50e94afb25b96ad29a0d1285483f208a.png";